import React, { useEffect, useState } from 'react';
import { List, Empty, Tag, Form } from 'antd';

import { createUseStyles } from 'react-jss'

import Icofont from 'react-icofont';

import uuid from 'react-uuid';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import { useSelector } from 'react-redux';
import { JSXMap, useAuth } from 'fennec-ui';
import Nl2Br from '../../../common/Nl2br';

var _ = require('lodash');

const useStyles = createUseStyles({
    selectPeople: {
        paddingBottom: "5px",
        '& .ant-input-prefix': {
            marginRight: "11px"
        },
        '& .ant-input-affix-wrapper': {
            padding: "4px 0px"
        }
    },
    listMeta: {
        '& .ant-list-item-meta-title': {
            marginBottom: "0"
        },
    },
    itemsListUsluga: {
        '& .ant-list .ant-list-item': {
            borderBottom: "1px solid #e1e1e1",
            alignItems: "flex-start"
        },
    },
    itemsOrderUsluga: {
        '& .ant-list-item': {
            alignItems: "flex-start"
        },
    },
    promo: {
        '& .ant-input-affix-wrapper': {
            paddingLeft: "0px",
        },
        '&': {
            borderBottom: "1px solid darkblue",
        },
        '&:hover': {
            borderBottom: "2px solid darkblue",
        },
    },
    appendButton: {
        '&.ant-btn': {
            width: "100%",
            backgroundColor: "#d9d9d9",
            boxShadow: "0px 1px 3px 0px rgba(141,141,141,0.74)",
            fontWeight: 600
        },
        '&.ant-btn:hover': {
            color: "#000",
            // background: #fff;
            boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
            borderColor: "#d9d9d9",
        },
        '&.ant-btn:focus': {
            color: "#000",
            // background: #fff;
            boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
            borderColor: "#d9d9d9",
        }
    }
})

const Header = ({ icon, title, style }) => {
    return (<span>
        <Icofont icon={icon} style={style} />
        <span>{title}</span>
    </span>);
};
const SingleHeader = () => {
    return (<Header icon="user-alt-3" title="Одиночный" style={{ color: "cadetblue", fontSize: "13px", paddingRight: "6px" }} />);
};
const FemaleHeader = () => {
    return (<Header icon="businesswoman" title="Женский" style={{ color: "red", fontSize: "16px", paddingRight: "6px" }} />);
};
const MaleHeader = () => {
    return (<Header icon="businessman" title="Мужской" style={{ color: "blue", fontSize: "16px", paddingRight: "6px" }} />);
};
const SelectCategory = (props) => {
    const { item, value } = props;
    const [selection, setSelection] = useState();
    const optionsFunc = (item) => {
        let dance = {};
        if (item) {
            item?.uslugiKlientuKategoriiUslugaKlienta?.forEach(e => {
                if (e.dostupnaRegistratsiya) {
                    dance[e.kategoriya.tantsevalnayaDistsiplinaID] = {
                        value: e.kategoriya.tantsevalnayaDistsiplinaID,
                        label: e.kategoriya.tantsevalnayaDistsiplina.nazvanie,
                        children: _.unionBy(
                            (dance[e.kategoriya.tantsevalnayaDistsiplinaID] && dance[e.kategoriya.tantsevalnayaDistsiplinaID].children) ? dance[e.kategoriya.tantsevalnayaDistsiplinaID].children : [],
                            [{
                                kategoriyaID: e.kategoriya.ID,
                                object: e,
                                ID: e.kategoriya.kategoriyaUchastnikovID,
                                value: e.kategoriya.kategoriyaUchastnikovID,
                                label: e.kategoriya.kategoriyaUchastnikov.nazvanie,
                            }],
                            'ID'),
                    }
                }
            });
        }
        return Object.values(dance);
    };
    useEffect(() => {
        if (value) {
            let a = optionsFunc(item);
            let o = [];
            for (let i = 0; i < a.length; i++) {
                const first = a[i];
                for (let j = 0; j < first.children.length; j++) {
                    const second = first.children[j];
                    if (second && value && value.kategoriya && second.kategoriyaID === value.kategoriya.kategoriyaID) {
                        o.push(first);
                        o.push(second);
                    }
                }
            }
            setSelection((o.length == 2) ? o : undefined);
        }
    }, [item, value])
    return (<span>
        <span> - </span>
        <span style={{ fontStyle: "italic" }}>
            <a onClick={(e) => e.preventDefault()}>{(selection) ? selection.map(o => o.label).join(' / ') : <span style={{ color: "red" }}>Укажите категорию!</span>}</a>
        </span>
    </span>);
};
const SelectPeople = (props) => {
    const classes = useStyles();
    const { data, prefix, value } = props;
    const display = (object) => {
        if (object === undefined) {
            return <span>Укажите участника!</span>;
        }
        if (object) {
            if (object.polzovatelStrokoi) {
                return <span>{object.polzovatelStrokoi}</span>;
            }
            if (object.polzovatel) {
                return <span>{object.polzovatel.firstname + " " + object.polzovatel.lastname}</span>;
            }
            return <span>Укажите участника!</span>;
        }
        return <></>;
    };
    const triggerFunc = React.useMemo(() => (click) => (<Tag color={(value === undefined) ? "red" : ""} onClick={click}>
        {display(value)}
    </Tag>), [value]);
    const filteredValue = (value && value.okazannieUslugiPolzovatelyamUchastik) ? value.okazannieUslugiPolzovatelyamUchastik.filter(i => i.uslugaKlientu.yacheikaUsluga.prilozhenieID) : undefined;
    return (<div className={classes.selectPeople}>
        <div>
            {prefix}
            <span style={{ paddingLeft: "10px" }}>{triggerFunc(() => { })}</span>
        </div>
        {!!value && <Services data={data} value={filteredValue} />}
    </div>);
};
const SelectPartner = (props) => {
    const auth = useAuth()
    const { item, value, onChange, data } = props;
    const user = useSelector(state => state.home.user);

    const display = (object) => {
        if (!object) {
            return <span>Укажите {(value?.tipTDID === 1) ? "ассистента" : "партнера"}!</span>;
        }
        if (object) {
            return <span>{object.firstname + " " + object.lastname}</span>;
        }
        return <></>;
    };

    return (<div style={{ display: "flex", gap: "5px" }}>
        <div style={{ fontStyle: "italic" }}> - {(value?.tipTDID === 1) ? "ассистент" : "партнер"} - </div>
        <div>
            {display(value?.partner)}
        </div>
    </div>);
};
const Services = (props) => {
    const { auth, data, value } = props;
    const find = (data, i) => {
        let o = (data) ? data.find(e => e.ID === i.uslugaKlientuID) : undefined;;
        return o;
    };
    return (<div style={{ paddingTop: "3px", fontSize: "13px" }}>
        {(!!value) && value.map((i, idx) =>
            <div key={idx}>
                <div>
                    <span>- {i.uslugaKlientu.yacheikaUsluga.nazvanie}</span>
                    <SelectCategory
                        auth={auth}
                        item={find(data, i)}
                        value={i}
                    />
                    {(i?.tipTDID === 1 || i?.tipTDID === 2) && <div>
                        <SelectPartner
                            auth={auth}
                            item={find(data, i)}
                            value={i}
                            data={data}
                        />
                    </div>}
                </div>
            </div>
        )}
    </div>);
};
const Male = (props) => {
    const { auth, item, index, value, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    const gender = 1;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            prefix={<MaleHeader />}
            item={item}
            index={index}
            data={data}
            value={value} />
    </div>);
};
const Female = (props) => {
    const { auth, item, index, value, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    const gender = 2;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            item={item}
            index={index}
            data={data}
            prefix={<FemaleHeader />}
            value={value} />
    </div>);
};
const Single = (props) => {
    const { auth, item, index, value, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={<SingleHeader />}
            item={item}
            index={index}
            data={data}
            value={value} />
    </div>);
};
const SingleByGender = (props) => {
    const { auth, item, index, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii : undefined;
    let genderID = value?.polzovatel?.genderID || value?.genderID;
    const setMergedObject = (obj) => {
        onChange({
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={(genderID == 1) ? <MaleHeader /> : (genderID == 2) ? <FemaleHeader /> : <Header icon="user-alt-3" title="" style={{ color: "cadetblue", fontSize: "13px" }} />}
            item={item}
            gender={genderID}
            index={index}
            data={data}
            value={value} />
    </div>);
};
const RenderCartItem = (props) => {
    const classes = useStyles();
    const { auth, item, index, uslugi } = props;
    const usluga = uslugi.find(e => e.Usluga?.ID === item?.uslugaNaMeropriyatii?.ID)?.Usluga;
    const description = (<div>
        {(!!item.uslugaNaMeropriyatii && !!item.uslugaNaMeropriyatii.opisanie) && <div style={{ fontSize: "13px" }}>
            <pre style={{
                margin: "0",
                padding: "0",
                whiteSpace: "pre-wrap",
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans- serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
            }}>
                {item.uslugaNaMeropriyatii.opisanie}
            </pre>
        </div>}
    </div>);
    const getPeopleByGender = (array, genderID) => {
        if (!array) return;
        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            if ((element.polzovatel && element.polzovatel.genderID === genderID) ||
                (element.genderID && element.genderID === genderID) ||
                (element.polzovatelStrokoi)) {
                return element;
            }
        }
    };
    return (<>
        <div style={{ flex: "auto" }}>
            <List.Item.Meta
                className={classes.listMeta}
                title={item.uslugaNaMeropriyatii.nazvanie}
                description={description}
            />
            <div style={{ alignSelf: "flex-start", textAlign: "start" }}>
                <div style={{ padding: "5px 0px" }}>
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 1) &&
                        <Male auth={auth} item={item} index={index}
                            value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 1)}
                            usluga={usluga} />
                    }
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 2) &&
                        <Female auth={auth} item={item} index={index}
                            value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 2)}
                            usluga={usluga} />
                    }
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 3) &&
                        <div style={{ display: "flex", justifyContent: "flex-start" }}>
                            <div>
                                {/* {JSXMap(item.polzovateliVZakazeTovarVZakaze, (e, idx) => {
                                    let genderID = e?.polzovatel?.genderID || e.genderID;
                                    return (<div key={idx} style={{ paddingBottom: "5px" }}>
                                        {genderID == 1 && <Male auth={auth} usluga={usluga} item={item} index={index}
                                            value={e} />}
                                        {genderID == 2 && <Female auth={auth} usluga={usluga} item={item} index={index}
                                            value={e}/>}
                                        {(genderID != 1 && genderID != 2) && <Single auth={auth} item={item} index={index}
                                            value={e}
                                            usluga={usluga} />}
                                    </div>)
                                })} */}
                                <div style={{ paddingBottom: "5px" }}>
                                    <SingleByGender auth={auth} usluga={usluga} item={item} index={index}
                                        value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")} />
                                </div>
                                <div style={{ paddingBottom: "5px" }}>
                                    <SingleByGender auth={auth} usluga={usluga} item={item} index={index}
                                        value={_.get(item, "polzovateliVZakazeTovarVZakaze[1]")} />
                                </div>
                            </div>
                        </div>}
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 4) &&
                        <Single auth={auth} item={item} index={index}
                            value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")}
                            usluga={usluga} />
                    }
                </div>
            </div>
            {(item?.uslugaNaMeropriyatii?.vklyuchitKommentarii == true) && <div style={{ maxWidth: "500px" }}>
                <div className='bg bg-transparent border-grey' style={{ fontSize: "12px", textAlign: "left", margin: "5px 0" }}>
                    <div style={{ fontSize: "11px", color: "rgba(0,0,0,.65)", display: "flex", justifyContent: "space-between" }}>
                        <div><i className="fa fa-comments-o"></i> Комментарий покупателя</div>
                        {/* <div><i className="fa fa-pencil-square-o"></i></div> */}
                    </div>
                    <div><Nl2Br text={item?.kommentarii} /></div>
                </div>
            </div>}
        </div>
        <div>
            <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "16px" }}>
                <div style={(item.tsena !== item.tsenaDoPromokoda) ? { textDecoration: "line-through" } : {}}>{(item.tsenaDoPromokoda).toLocaleString()} руб.</div>
                {(item.tsena !== item.tsenaDoPromokoda) && <div style={{ color: "red" }}>{(item.tsena).toLocaleString()} руб.</div>}
            </div>
        </div>
    </>)
};
function CollectionList(props) {
    const classes = useStyles();
    const { auth, zakaz, uslugi } = props;
    const [loading, setLoading] = useState(false);
    return (
        <div>
            <List
                className={classes.itemsOrderUsluga}
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Не выбраны абонементы" /> }}
                style={{ borderBottom: "1px solid #f0f0f0" }}
                itemLayout="horizontal"
                dataSource={(zakaz) ? zakaz.tovariVZakazeZakaz : []}
                loading={loading}
                renderItem={(item, index) => (
                    <List.Item>
                        <RenderCartItem auth={auth} uuid={uuid()} item={item} index={index} uslugi={uslugi} zakaz={zakaz} promo={zakaz.promokod} />
                    </List.Item>
                )}
            />
            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "500", fontSize: "16px", padding: "10px 0px 0px 0px" }}>                <div>
                ИТОГО:
            </div>
                {(zakaz && zakaz.obshchayaSumma) && <div>
                    {(zakaz.obshchayaSumma).toLocaleString()} руб.
                </div>}
            </div>
        </div>
    );
}

function Dimmy({ constant, value, onChange, render }) {
    useEffect(() => {
        onChange(constant || value);
    }, [constant, value]);
    return <>{render && render(constant || value)}</>;
}
export default function PaymentPreview(props) {

    const { auth, form, data } = props;
    const [zakaz, setZakaz] = useState({});
    // const [messages, setMessages] = useState([]);
    const [uslugi, setUslugi] = useState([]);
    const [akkaunti, setAkkaunti] = useState();
    const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);
    useEffect(() => {
        form.resetFields();
    }, []);
    useEffect(() => {
        setZakaz(data.cart.zakaz);
        // setMessages(data.cart.messages);
        setUslugi(data.cart.data);
    }, [data]);
    useEffect(() => {
        if (akkauntiPolzovatelei) {
            setAkkaunti(akkauntiPolzovatelei.map(e => e.akkaunt));
        }
    }, [akkauntiPolzovatelei]);

    const ByAccount = (akkaunti) => {
        if (!akkaunti) return {};
        for (let i = 0; i < akkaunti.length; i++) {
            const akkaunt = akkaunti[i];
            if (akkaunt && akkaunt?.akkauntTypeID == 2) {
                return akkaunt;
            }
        }
        return {};
    };
    const acc = ByAccount(akkaunti);
    const payCard = () => {
        if (!zakaz) return 0;
        if (!acc) return 0;
        if (!data?.cart?.razreshitSpisanieSoScheta) return zakaz.obshchayaSumma;
        if (zakaz.obshchayaSumma - acc.ostatok < 0) return 0;
        return (zakaz.obshchayaSumma - acc.ostatok);
    };
    const payAcc = () => {
        if (!acc.ostatok) return 0;
        if (!data?.cart?.razreshitSpisanieSoScheta) return 0;
        if (acc.ostatok >= zakaz.obshchayaSumma) return zakaz.obshchayaSumma;
        if (acc.ostatok < zakaz.obshchayaSumma) return acc.ostatok;
        return 0;
    };

    return (
        <>
            <div style={{ fontSize: "24px" }}>
                Подтверждение заказа
            </div>
            <CollectionList auth={auth} zakaz={zakaz} promo={zakaz.promokod} uslugi={uslugi} />
            {akkaunti && <div style={{ fontWeight: "500", fontSize: "14px", padding: "10px 0px 25px 0px" }}>
                <Form
                    form={form}
                    onFinish={props.submit}
                    labelAlign={"left"}
                    layout={"vertical"}
                >
                    <Form.Item
                        name="fromAccount"
                    >
                        <Dimmy constant={payAcc()} render={(value) =>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div>
                                    {/* {(payAcc()<0)?`Долг по счету №${acc.nomerAkkaunta}:`:`Спишем со счета №${acc.nomerAkkaunta}:`} */}
                                    {value && ((value < 0) ? `Долг по счету:` : `Спишем со счета:`)}
                                </div>
                                <div>
                                    {value && ((value < 0) ? Math.abs(value).toLocaleString() + " руб." : value.toLocaleString() + " руб.")}
                                </div>
                            </div>
                        } />
                    </Form.Item>
                    <Form.Item
                        name="byCard"
                    >
                        <Dimmy constant={payCard()} render={(value) =>
                            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "18px", color: "red" }}>
                                <div>
                                    ОПЛАТИТЬ КАРТОЙ:
                                </div>
                                <div>
                                    {(value === undefined) ? 0 : value.toLocaleString()} руб.
                                </div>
                            </div>
                        } />
                    </Form.Item>
                </Form>
            </div>}
        </>
    );
}
// PaymentForm.whyDidYouRender = true
// CollectionList.whyDidYouRender = true
